import { Button, MagellanPopup } from 'components/atoms';
import CensoriousSelectCard from 'components/molecules/card/censorious-select/CensoriousSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { TRACK_CENSORIOUS } from 'services/tracks/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface ICensoriousSelectPopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectCensorious?: (censorious: TRACK_CENSORIOUS | null, actions: PopupActions) => void;
  open?: boolean;
  initialCensorious?: TRACK_CENSORIOUS | null;
  displayMode?: boolean;
}

const CensoriousSelectPopupForm = ({
  trigger,
  onSelectCensorious,
  open,
  initialCensorious = null,
  displayMode,
}: ICensoriousSelectPopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [censoriousSearch, setCensoriousSearch] = useState('');
  const [selectedCensorious, setSelectedCensorious] = useState<TRACK_CENSORIOUS | null>(null);

  return displayMode ? (
    <>{trigger}</>
  ) : (
    <Popup
      ref={popupRef}
      open={open}
      onOpen={() => {
        setSelectedCensorious(initialCensorious);
      }}
      onClose={() => {
        setSelectedCensorious(null);
        setCensoriousSearch('');
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('input.label.censorious')}</MagellanPopup.Header>

        {/* <Input.Text
          value={censoriousSearch}
          onChange={(e) => setSelectedCensorious(e.target.value)}
          name=""
          appBackground
          placeholder={t('input.placeholder.search-censorious')}
        /> */}
        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none]  gap-2">
          {Object.values(TRACK_CENSORIOUS)
            .filter((censorious) => typeof censorious === 'string' && censorious !== 'unknown')
            .filter((censorious) =>
              t(`censorious.${censorious}.name`)
                .toLowerCase()
                .includes(censoriousSearch.toLowerCase()),
            )
            .map((censorious) => {
              const convertedCensorious =
                TRACK_CENSORIOUS[censorious as keyof typeof TRACK_CENSORIOUS];
              return (
                <CensoriousSelectCard
                  key={censorious}
                  censorious={convertedCensorious}
                  isSelected={selectedCensorious === convertedCensorious}
                  onClick={(newCensorious) =>
                    setSelectedCensorious((prev) => (prev === newCensorious ? null : newCensorious))
                  }
                />
              );
            })}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() =>
              popupRef.current &&
              onSelectCensorious &&
              onSelectCensorious(selectedCensorious, popupRef.current)
            }
          >
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default CensoriousSelectPopupForm;
